<template>
  <div class="index" v-if="showIndex">
    <div class="left-nav">
      <!--顶部logo-->
      <div class="row flex-center logo-area">
        <div class="logoimg">
          <img class="logoimg-img" :src="logimg" />
        </div>
      </div>
      <!--导航栏目滚动区域-->
      <div class="nav-scroll-area flex-1">
        <el-scrollbar>
          <div
            class="nav-item column flex-center"
            :class="activeKey === item.key ? 'active' : ''"
            v-for="(item, index) in leftNavList"
            :key="leftNavVersion + '-' + (item.key || index)"
            @click="handleNavClick(item)"
          >
            <i class="iconfont navitem-icon" :class="item.icon"></i>
            <span class="navitem-right-text">{{ item.label }}</span>
            <div class="blockright" v-if="activeKey === item.key"></div>
          </div>
        </el-scrollbar>
      </div>
      <div class="nav-scroll-bottom">
        <el-dropdown
          placement="top-start"
          trigger="click"
          @command="handleCommand"
        >
          <div class="nav-scroll-bottom-dropdown">
            <el-icon size="15"><Tools /></el-icon>
            <span class="nav-scroll-bottom-text">设置</span>
          </div>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item command="changeClinic">
                切换门店
              </el-dropdown-item>
              <el-dropdown-item command="reLogin">重新登录</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>
    <div class="right-content column">
      <!-- <!~~ 顶部固定 ~~> -->
      <!-- <div class="topinfo shrink0 row">{{ activeName }}</div> -->
      <!-- 主内容区：占满右侧剩余高度，子页面内再滚动（与 workspace-section 表格布局一致） -->
      <div class="content-scroll-area flex-1">
        <router-view v-slot="{ Component }">
          <div class="pc-main-route">
            <component :is="Component" />
          </div>
        </router-view>
      </div>
    </div>
  </div>

  <!--选择门店-->
  <PcSelectStore
    v-if="selectStoreState.isShow"
    :clinicList="clinicList"
    :self="selectStoreState"
    @selectClinic="setCurrentClinic"
  />

  <PLoading></PLoading>
</template>

<script>
import { userStore } from "@/store/user.js";
import logimg from "@/assets/pc/img/logo.png";
import siderleft from "@/assets/pc/img/sidebar-left.png";
import siderright from "@/assets/pc/img/sidebar-right.png";
import PcSelectStore from "@/components/pc/public/pcSelectStore.vue";

import { getClinicListByWecom } from "@/api/options.js";
import {
  checkMenuPowers,
  clearWecomAgentPowers,
  fetchWecomAgentPowers,
} from "@/util/power/index.js";
import func from "@/util/func.js";

export default {
  name: "index",
  data() {
    return {
      // 左侧导航列表版本号，用于权限更新后触发菜单节点重建
      leftNavVersion: 0,
      activeKey: "",
      leftNavList: [
        {
          label: "工作台",
          key: "clinicWorkspace",
          icon: "icon-home1",
          powerCode: "wecom_agent_workbench",
        },
        {
          label: "我的待办",
          key: "myWorkspace",
          icon: "icon-daiban",
          powerCode: "wecom_agent_todo",
        },
        {
          label: "患者",
          key: "customerManagement",
          icon: "icon-huanzhe",
          powerCode: "wecom_agent_patient",
        },
        {
          label: "线索",
          key: "clueManagement",
          icon: "icon-xiansuo",
          powerCode: "wecom_agent_lead",
        },
        {
          label: "好友",
          key: "friendManagement",
          icon: "icon-haoyou",
          powerCode: "wecom_agent_contact",
        },
        {
          label: "群聊",
          key: "groupChat",
          icon: "icon-haoyou",
          powerCode: "wecom_agent_group_chat",
        },
        {
          label: "聊天记录",
          key: "wecomChat",
          icon: "icon-baogao",
          powerCode: "wecom_agent_message",
        },
        {
          label: "统计报表",
          key: "statisticsReport",
          icon: "icon-baobiao",
          powerCode: "wecom_agent_statistic",
        },
        {
          label: "数据报表",
          key: "dataReport",
          icon: "icon-baobiao",
          powerCode: "wecom_agent_data_stat",
        },
        {
          label: "跟进计划",
          key: "followUpPlan",
          icon: "icon-genjin",
          powerCode: "wecom_agent_follow",
        },
        {
          label: "报告检查",
          key: "reportCheck",
          icon: "icon-Diagnosis",
          powerCode: "wecom_agent_report",
        },
        {
          label: "管理",
          key: "manage",
          icon: "icon-shez",
          powerCode: "wecom_agent_manager",
        },
      ],
      leftNavListBack: [],
      selectStoreState: {
        isShow: false,
      },
      logimg,
      siderleft,
      siderright,
      showIndex: false, //显示主页
      loading: null,
      clinicList: [],
      userName: "", //用户名
    };
  },
  components: { PcSelectStore },
  watch: {
    $route(to) {
      this.syncActiveKeyByRoute(to);
    },
  },
  created() {
    // 页面首次进入后按当前地址初始化高亮，兼容外部链接直达或后退前进场景
    this.syncActiveKeyByRoute(this.$route);
  },
  mounted() {
    this.leftNavListBack = func.copyArr(this.leftNavList);
    const user = userStore();
    //开始刷新Token的监听
    user.testHasToken().then(async () => {
      this.loadClinicList();
    });
  },
  methods: {
    getUserName() {
      const user = userStore();
      this.userName = user.userInfo.nick_name;
    },
    /**
     * 获取门店列表，仅保留展示所需，不处理跳转
     */
    loadClinicList() {
      const that = this;
      const user = userStore();
      const { corpId, cusId, userInfo } = user || {};

      that.loading?.showLoading?.();
      getClinicListByWecom({ corpId, cusId })
        .then((res) => {
          let currentClinicId = userInfo.detail.clinic_id;
          that.clinicList = res?.data?.data || [];

          if (that.clinicList.length === 1) {
            //token接口登录默认的诊所是员工的归属诊所
            //模拟点击选择门店，刷新token，切换到和企微关联的门店，防止没有菜单
            that.setCurrentClinic(that.clinicList[0]);
          } else {
            // 将当前门店ID对应的元素放到数组第一个
            const currentClinicIndex = that.clinicList.findIndex(
              (clinic) => clinic.id == currentClinicId,
            );
            if (currentClinicIndex > 0) {
              const currentClinic = that.clinicList.splice(
                currentClinicIndex,
                1,
              )[0];
              that.clinicList.unshift(currentClinic);
            }
            that.selectStoreState.isShow = true;
          }
        })
        .finally(() => {
          that.loading?.hideLoading?.();
        });
    },
    /**
     * 初始化左侧导航权限
     * 1. 拉取后端菜单权限并缓存本地
     * 2. 按 powerCode 过滤 leftNavList，空 powerCode 默认展示
     */
    async initLeftNavByPower() {
      const allPowerCodeList = this.leftNavListBack
        .map((navItem) => navItem.powerCode)
        .filter((navItem) => !!navItem);

      try {
        await fetchWecomAgentPowers();
      } catch (error) {
        console.error("权限初始化失败，使用本地权限兜底", error);
      }

      const menuPermissionMap = checkMenuPowers(allPowerCodeList);
      this.leftNavList = this.leftNavListBack.filter((navItem) => {
        if (!navItem.powerCode) {
          return true;
        }
        return menuPermissionMap[navItem.powerCode] === true;
      });

      // 权限列表更新后通过版本号强制重新渲染导航菜单
      this.leftNavVersion += 1;
    },

    /**
     * 处理导航项点击事件
     * @param {Object} item - 导航项对象，包含 label 和 key
     */
    handleNavClick(item) {
      this.$router.push(`/pc/${item.key}`);
      this.activeKey = item.key;
      document.title = item.label;
    },
    checkStore() {
      //检查token中是否有门店信息，如果没有门店信息需要弹出选择门店的弹出层，
      //选择完成门店以后重新获取token存储到store中
      const that = this;
      that.selectStoreState.isShow = true;
    },
    setCurrentClinic(e) {
      const that = this;

      //统一处理选择门店刷新token后的操作
      async function handleSuccess(that) {
        clearWecomAgentPowers();
        //刷新权限位
        await that.initLeftNavByPower();

        if (that.leftNavList.length > 0) {
          //确保打开的是有权限的菜单
          that.handleNavClick(that.getDefaultMenuItem());
        } else {
          //跳转到空白页
          that.$router.push("/pc/entry");
        }

        const user = userStore();
        user.refreshTokenTime();
        that.getUserName();
        that.showIndex = true;
        that.selectStoreState.isShow = false;
      }

      //开发环境
      if (process.env.NODE_ENV === "development") {
        // console.log('开发环境');
        handleSuccess(that);
        return;
      }

      const user = userStore();

      user
        .replacementClinic(e.id)
        .then(() => {
          return handleSuccess(that);
        })
        .catch((err) => {
          if (err == "refresh_token is empty") {
          }
        });
    },
    //获取加载时打开的菜单
    getDefaultMenuItem() {
      const { path } = this.$router.currentRoute.value;
      const keyList = path.split("/");
      //解析说明：/pc/reportCheck/selectClinic->["","pc","reportCheck","selectClinic"]
      //左侧导航栏高亮设置
      const key = keyList[2];
      //页面标题设置
      const target = this.leftNavList.find((item) => item.key === key);
      //有路由对应的菜单则返回
      if (target) {
        return target;
      }
      //没有路由对应的菜单则返回第一个菜单
      return this.leftNavList[0];
    },
    /**
     * 按当前路由同步左侧导航高亮项
     * 仅当路径为 /pc/groupChat（或其子路径）时，强制高亮“群聊”
     */
    syncActiveKeyByRoute(routeInfo) {
      const ROUTE_PATH = (routeInfo && routeInfo.path) || "";
      const IS_GROUP_CHAT_PATH =
        ROUTE_PATH === "/pc/wecomChat" ||
        ROUTE_PATH.startsWith("/pc/wecomChat/");

      if (IS_GROUP_CHAT_PATH) {
        const groupChatItem = this.leftNavList.find(
          (item) => item.key === "wecomChat",
        );
        if (groupChatItem) {
          this.activeKey = groupChatItem.key;
          document.title = groupChatItem.label;
        }
      }
    },
    //左下角设置菜单点击事件
    handleCommand(command) {
      const that = this;
      if (command === "changeClinic") {
        //切换门店，隐藏主页，显示选择门店弹窗
        that.showIndex = false;
        that.selectStoreState.isShow = true;
      } else if (command === "reLogin") {
        //清除缓存，重新登录
        const user = userStore();

        user.clearStorageAndReload('/pc/clinicWorkspace');
      }
    },
  },
};
</script>

<style scoped="scoped" lang="scss">
.index {
  display: flex;
  width: 100%;
  height: 100vh;
  background-color: #fff;
  font-size: 14px;
  overflow: hidden;

  .left-nav {
    width: 80px;
    height: 100%;
    flex-shrink: 0;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    border-right: 1px solid #e6e6e6;
    padding: 20px 0 0 0px;
    transition: width 0.3s ease;

    // 顶部logo区域
    .logo-area {
      width: 100%;
      padding: 0 10px;
      margin-bottom: 10px;
      flex-shrink: 0;

      .logoimg {
        width: 50px;
        height: 50px;
        margin: 0 auto;

        .logoimg-img {
          width: 50px;
          height: 50px;
          object-fit: contain;
        }
      }
    }

    // 导航滚动区域
    .nav-scroll-area {
      width: 100%;
      height: 0;
      padding: 0;

      .nav-item {
        width: 100%;
        min-height: 40px;
        padding: 12px 0;
        background-color: #fff;
        color: #666666;
        text-align: left;
        line-height: 24px;
        cursor: pointer;
        transition: all 0.3s;
        white-space: nowrap;
        position: relative;

        .navitem-icon {
          font-size: 24px;
          color: #cccccc;
          margin-bottom: 6px;
        }

        .navitem-right-text {
          text-align: center;
          font-size: 12px;
          color: #666666;
          line-height: 1;
        }

        &:hover {
          background-color: #f5f5f5;
        }

        &.active {
          background-color: #28b8c3;

          .navitem-icon {
            color: #fff;
          }
          .navitem-right-text {
            color: #fff;
          }
        }
      }
    }

    // 导航栏底部区域
    .nav-scroll-bottom {
      width: 100%;
      border-top: 1px solid #e6e6e6;
      flex-shrink: 0;
      background-color: #f7f7f7;
      color: #666;

      .nav-scroll-bottom-dropdown {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 12px 4px;

        .nav-scroll-bottom-text {
          font-size: 14px;
          margin-left: 4px;
          user-select: none;
        }
      }
    }
  }

  .right-content {
    flex: 1;
    width: 0;
    min-width: 800px;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    // 顶部固定区域
    .topinfo {
      width: 100%;
      padding: 12px 20px;
      font-size: 16px;
      font-weight: 500;
      color: #333;
      background-color: #ffffff;
      border-bottom: 1px solid #e6e6e6;
    }

    // 主内容区：由子页面内部 table-container 滚动，此处不整体滚动
    .content-scroll-area {
      width: 100%;
      min-height: 0;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      background-color: #f6f6f6;
    }

    .pc-main-route {
      flex: 1 1 0;
      min-height: 0;
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }
  }
}
</style>
